import React from "react";
import { PayPalScriptProvider, PayPalButtons } from "@paypal/react-paypal-js";
import { PAYPAL_CLIENT_ID } from "../../config/Api_url";
import PostRequest from "../../services/PostRequest";
import { showToaster } from "../../common/common";

const PaypalSubscriptionPayment = ({ plan, onApprove }) => {
  return (
    <PayPalScriptProvider
      options={{ "client-id": PAYPAL_CLIENT_ID, vault: true }}
    >
      <PayPalButtons
        style={{
          layout: "vertical",
          shape: "rect",
          color: "gold",
          label: "subscribe",
          height: 45,
          tagline: false,
        }}
        createSubscription={async (data, actions) => {
          // Billing rebuild: fetch a server-signed custom_id binding (user, plan)
          // and the server-resolved paypal_plan_id, then create the subscription
          // carrying custom_id so every webhook/GET proves the owner (B6).
          const intent = await PostRequest("/plans/subscription/intent/", {
            plan: plan.code || plan.id,
          });
          const subscriptionID = await actions.subscription.create({
            plan_id: intent.paypal_plan_id || plan.paypal_plan_id,
            custom_id: intent.custom_id,
          });
          // Pre-create the pending row so the sale webhook can resolve it even if
          // it lands before activate. Non-fatal — the webhook bootstraps from the
          // signed custom_id otherwise — so never abort the buyer's flow on this.
          try {
            await PostRequest("/plans/subscription/register/", { subscriptionID });
          } catch (e) {
            console.log("register failed, relying on webhook bootstrap:", e);
          }
          return subscriptionID;
        }}
        onApprove={async (data, actions) => {
          try {
            // Server verifies the subscriber identity matches the caller and
            // promotes the subscription; the webhook performs the credit grant.
            await PostRequest("/plans/subscription/activate/", {
              subscriptionID: data.subscriptionID,
            });
            onApprove();
          } catch (error) {
            // The buyer has already been charged by PayPal at this point — never
            // swallow silently. The webhook may still grant; ask them to refresh.
            console.log("Subscription Error:", error);
            showToaster(
              "Payment received — activation is still processing. Please refresh in a minute; if your plan does not appear, contact support.",
              "error"
            );
          }
        }}
      />
    </PayPalScriptProvider>
  );
};

export default PaypalSubscriptionPayment;
